import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {isNullOrUndefined} from "util";
import {find, filter, remove} from "lodash";
import {Observable} from "rxjs";


export class ChipAnswer {
    id: number;
    name: string;
}

@Component({
    selector: 'tfl-chip',
    template: require('./chip.component.html')
})
export class ChipComponent {

    @Input() minSearchChars = 1;
    @Input() predefinedValues: ChipAnswer[] = [];

    @Output() chipSelected = new EventEmitter<ChipAnswer>();
    @Output() chipRemoved = new EventEmitter<ChipAnswer>();

    @ViewChild('entryInput') entryInput: ElementRef;

    @Input() enteredValues: ChipAnswer[] = [];

    remove(entryToRemove: ChipAnswer): void {
        this.chipRemoved.next(entryToRemove);
        remove(this.enteredValues, value => value.id === entryToRemove.id);
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        if (event.option.value) {
            this.enteredValues.push(event.option.value);
            this.chipSelected.next(event.option.value);
        }
        this.entryInput.nativeElement.value = '';
    }

    getFilteredValues(): Observable<Array<ChipAnswer>> {
        let searchWord = this.entryInput.nativeElement.value;
        if (this.shouldBeEmptyValuesList(searchWord)) {
            return Observable.of([]);
        }
        let result = this.predefinedValues;
        if (this.enteredValues.length > 0) {
            result = filter(this.predefinedValues, value => isNullOrUndefined(find(this.enteredValues, pred => pred.id === value.id)));
        }
        return Observable.of(filter(result, value => value.name.toLowerCase().indexOf(searchWord.toLowerCase()) >= 0));
    }

    onClick(event: any) {
        if (this.minSearchChars === 0) {
            setTimeout(() => {
                this.entryInput.nativeElement.blur();
                this.entryInput.nativeElement.focus();
            });
        }
    }

    private shouldBeEmptyValuesList(searchWord: string): boolean {
        return isNullOrUndefined(this.predefinedValues)
            || (this.minSearchChars > 0
                && searchWord.length <= this.minSearchChars)
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/chip/chip.component.ts